import Main from './Main'
import Lista from './components/SituacaoAvisoRecebimento'
import Novo from './components/NovaSituacaoAvisoRecebimento'

export default [
  {
    path: 'pc-situacaoavisorecebimento',
    name: 'policiacivil.notificacao.situacaoavisorecebimento',
    component: Main,
    redirect: { name: 'policiacivil.notificacao.situacaoavisorecebimento.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.notificacao.situacaoavisorecebimento.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.notificacao.situacaoavisorecebimento.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.notificacao.situacaoavisorecebimento.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/notificacao/situacao-aviso-recebimento/routes.js